export default __webpack_public_path__ + "static/media/slider05.63a6577d.png";